export const documentsKeys = {
  get: (workOrderOperationId?: string | null) =>
    ["documents", workOrderOperationId] as const,
  getFile: (id: string) => ["file", id] as const,
  getEntityDocuments: (entityId: string) =>
    ["entityDocuments", entityId] as const,
  getAll: () => ["documents"],
  getDocument: (id: string) => ["documents", id],
};
